import { type SVGAttributes } from "react";

export function MarkerIcon({ ...props }: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.73598 12.4151C4.22379 8.54856 7.18233 3.58682 12 3.58682C16.8177 3.58682 19.7763 8.54856 17.2641 12.4151L13.0913 18.8375C12.0585 20.3346 12.0274 20.2724 10.9088 18.8375L6.73598 12.4151Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <circle cx="12" cy="9.08682" r="2.5" stroke="white" strokeWidth="1.5" />
    </svg>
  );
}
